import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import CheckoutForm from "../components/CheckoutForm";

function Checkout() {
	const location = useLocation();
	const packageData = location.state?.packageData;

	// If no package data, redirect or show error
	if (!packageData) {
		return (
			<div className="flex flex-col items-center justify-center min-h-screen">
				<Helmet>
					<title>Checkout Error | Steer Smart Driving School</title>
					<meta
						name="description"
						content="Please select a driving lesson package to proceed with checkout at Steer Smart Driving School."
					/>
					<meta name="robots" content="noindex, nofollow" />
				</Helmet>
				<h1 className="text-2xl font-bold text-steerOrange mb-4">
					No Package Selected
				</h1>
				<p className="text-gray-600">
					Please select a package to proceed with checkout.
				</p>
			</div>
		);
	}

	const cartItems = [packageData]; // Convert single package to array for compatibility
	const totalPrice = packageData.price;

	return (
		<div className="flex flex-col lg:flex-row items-center justify-center w-full py-6 lg:space-x-12 lg:space-y-0 space-x-0 space-y-6">
			<Helmet>
				<title>Checkout | Steer Smart Driving School</title>
				<meta
					name="description"
					content="Complete your driving lesson package purchase at Steer Smart Driving School. Secure checkout for your selected driving lesson package."
				/>
				<meta name="robots" content="noindex, nofollow" />
			</Helmet>
			{/* Sidebar */}
			<div className="flex flex-col items-center justify-start space-y-12 py-6 w-full lg:w-1/3 p-4 rounded-lg">
				<h1 className="font-[600] font-generalSans text-4xl text-center text-steerBlack lg:xl:text-4xl dark:text-white py-6">
					Selected Package
				</h1>

				{/* Package Details */}
				<div className="flex flex-col space-y-12 w-full">
					<div className="">
						<div className="bg-white/60 backdrop-blur-md p-6 rounded-2xl w-full">
							<div className="text-center space-y-4">
								<h3 className="font-bold text-gray-800 text-lg">
									{packageData.title}
								</h3>
								<p className="text-gray-600 text-sm">
									{packageData.description}
								</p>
								{/* <p className="font-semibold text-steerOrange text-2xl">
									${packageData.price}
								</p> */}
							</div>
						</div>
					</div>

					<div className="flex justify-between items-center bg-steerBlack dark:bg-gray-800 p-4 rounded-2xl w-full">
						<h3 className="font-bold text-white">Total:</h3>
						<p className="font-semibold text-white dark:text-[#FF7800]">
							${totalPrice.toFixed(2)}
						</p>
					</div>
				</div>
			</div>

			<div className="xl:flex hidden"></div>

			<div className="xl:flex hidden"></div>

			{/* Main Content */}
			<div className="flex flex-col items-center justify-end w-full lg:w-2/3">
				<CheckoutForm cartItems={cartItems} />
			</div>
		</div>
	);
}

export default Checkout;
